import { connect } from "react-redux";

export { default as feedbackReduser } from "./feedback.reducer";
export * from "./feedback.actions";
import Feedback from "./feedback";

export default connect(({ feedback: { message } }: any) => {
  return { message };
})(Feedback);
